var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66619 0C2.09292 0 0 2.09292 0 4.66619V11.3338C0 13.9071 2.09292 16 4.66619 16H11.3338C13.9071 16 16 13.9071 16 11.3338V4.66619C16 2.09292 13.9071 0 11.3338 0H4.66619ZM12.6719 2.66476C13.0379 2.66476 13.3352 2.96212 13.3352 3.32809C13.3352 3.69407 13.0379 3.99142 12.6719 3.99142C12.3059 3.99142 12.0086 3.69407 12.0086 3.32809C12.0086 2.96212 12.3059 2.66476 12.6719 2.66476ZM8.00572 4.00286C10.213 4.00286 12.0086 5.79843 12.0086 8.00572C12.0086 10.213 10.213 12.0086 8.00572 12.0086C5.79843 12.0086 4.00286 10.213 4.00286 8.00572C4.00286 5.79843 5.79843 4.00286 8.00572 4.00286ZM8.00572 5.34096C6.53038 5.34096 5.34096 6.53038 5.34096 8.00572C5.34096 9.48106 6.53038 10.6705 8.00572 10.6705C9.48106 10.6705 10.6705 9.48106 10.6705 8.00572C10.6705 6.53038 9.48106 5.34096 8.00572 5.34096Z",
    fill: "#D3D3E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInsta);
export default __webpack_public_path__ + "static/media/footerInsta.9b8994f9071dcf4cda9eb71d2a19a5b2.svg";
export { ForwardRef as ReactComponent };